export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-3a82dd957ee044e28dc83f4b8a386a8e.svg";